export class AppTaskCategory{

  Entry_No : number;
  Description : string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/AppTaskCategory.ts